import styled from 'styled-components';
import { CFBaseIconStyles, } from '@connectrn/ds-ui-base';
export const CFIconElements = {
    IconSVG: styled.svg `
    ${CFBaseIconStyles.IconSVG};
  `,
    Wrapper: styled.div `
    ${CFBaseIconStyles.Wrapper};
    ${CFBaseIconStyles.WrapperWeb};
  `,
};
